import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { MsalService } from '@azure/msal-angular';
import { Observable } from 'rxjs';
import { BaseApiService } from './api-base.service';
import { HelperService } from './helper.service';
import { CarePlan } from '../models/careplan.model';
import { ServicePlanDetail } from '../models/serviceplandetail.model';

@Injectable({
  providedIn: 'root'
})
export class CarePlanService extends BaseApiService {
  private env: string;

  constructor(
    http: HttpClient,
    msalService: MsalService,
    private helperService: HelperService
  ) {
    super(http, msalService);
    this.env = this.helperService.getStoredValue('ecase_env', 'prod');
  }

  getClientCarePlan(clientId: string): Observable<CarePlan> {
    const url = `${this.apiUrl}/ecase/${this.env}/clientserviceplan/${clientId}`;
    return this.get<CarePlan>(url);
  }

  getServicePlanDetails(servicePlanId: string): Observable<ServicePlanDetail> {
    const url = `${this.apiUrl}/ecase/${this.env}/serviceplandetails/${servicePlanId}`;
    return this.get<ServicePlanDetail>(url);
  }

  getRateWindow(activityData: any): Observable<{message: string, start_time: string | null, end_time: string | null}> {
    const url = `${this.apiUrl}/ecase/${this.env}/rate-window/`;
    return this.post<{message: string, start_time: string | null, end_time: string | null}>(url, activityData);
  }

  // updateKeyStaff() REMOVED (eCase #6542, 2026-09): the /careplan/keystaff/ write made
  // eCase accumulate duplicate group-activity entries that block plan deactivation and
  // movement-out. The endpoint is disabled server-side; re-add when key-staff editing is
  // rebuilt in keystone / the scheduler.

  // updateServicePlanTiming() removed (eCase #6542): permanent care-plan time change
  // disabled server-side; re-add when rebuilt in keystone / the scheduler.

  refreshClientServicePlanCache(clientId: string): Observable<any> {
    // Ensure clientId is provided
    if (!clientId) {
      console.error("Client ID is required to refresh the service plan cache.");
      // Return an observable that emits an error or an empty value,
      // depending on how you want to handle this case.
      // For now, let's return an empty observable to avoid breaking the chain.
      // Consider adding proper error handling or notification.
      return new Observable(observer => {
        observer.error('Client ID is missing');
        observer.complete();
      });
      // Or perhaps: return throwError(() => new Error('Client ID is missing'));
    }
    const url = `${this.apiUrl}/ecase/${this.env}/refresh/clientserviceplan/${clientId}`;
    console.log(`[CarePlanService] Refreshing cache for client ID: ${clientId} at URL: ${url}`); // Optional: Add logging
    return this.get(url);
  }
}
